 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ContactGroups-vue":"ContactGroups-vue","Contacts-vue":"Contacts-vue","Search-vue":"Search-vue","auth-Login-vue":"auth-Login-vue","auth-Register-vue":"auth-Register-vue","chart-LineChart-vue~chart-PieChart-vue":"chart-LineChart-vue~chart-PieChart-vue","chart-LineChart-vue":"chart-LineChart-vue","chart-PieChart-vue":"chart-PieChart-vue","contact-communicationHistory-EmailFormDialog-vue":"contact-communicationHistory-EmailFormDialog-vue","contact-Group-vue~contact-Index-vue~contact-ledger-List-vue":"contact-Group-vue~contact-Index-vue~contact-ledger-List-vue","contact-Group-vue":"contact-Group-vue","contact-activities-Index-vue":"contact-activities-Index-vue","contact-communicationHistory-Index-vue":"contact-communicationHistory-Index-vue","contact-group-Index-vue":"contact-group-Index-vue","contact-information-Index-vue":"contact-information-Index-vue","contact-activities-AppointmentFormDialog-vue":"contact-activities-AppointmentFormDialog-vue","contact-activities-NoteFormDialog-vue":"contact-activities-NoteFormDialog-vue","contact-information-StudentFormDialog-vue":"contact-information-StudentFormDialog-vue","contact-communicationHistory-SmsFormDialog-vue":"contact-communicationHistory-SmsFormDialog-vue","common-PageHeader-vue":"common-PageHeader-vue","contact-ContactDetail-vue":"contact-ContactDetail-vue","contact-Detail-vue":"contact-Detail-vue","contact-FormDialog-vue":"contact-FormDialog-vue","contact-Index-vue":"contact-Index-vue","contact-ledger-List-vue":"contact-ledger-List-vue","contact-Header-vue":"contact-Header-vue","contact-activities-AppointmentList-vue":"contact-activities-AppointmentList-vue","contact-activities-List-vue":"contact-activities-List-vue","contact-activities-NotesList-vue":"contact-activities-NotesList-vue","contact-communicationHistory-Calls-vue":"contact-communicationHistory-Calls-vue","contact-communicationHistory-Email-vue":"contact-communicationHistory-Email-vue","contact-communicationHistory-Inquiry-vue":"contact-communicationHistory-Inquiry-vue","contact-communicationHistory-Sms-vue":"contact-communicationHistory-Sms-vue","contact-group-Add-vue":"contact-group-Add-vue","contact-group-GroupList-vue":"contact-group-GroupList-vue","contact-group-GuardianList-vue":"contact-group-GuardianList-vue","contact-group-StudentList-vue":"contact-group-StudentList-vue","contact-information-GroupFormDialog-vue":"contact-information-GroupFormDialog-vue","contact-information-GroupList-vue":"contact-information-GroupList-vue","contact-information-GuardianFormDialog-vue":"contact-information-GuardianFormDialog-vue","contact-information-GuardianList-vue":"contact-information-GuardianList-vue","contact-information-InformationFormDialog-vue":"contact-information-InformationFormDialog-vue","contact-information-StudentList-vue":"contact-information-StudentList-vue","contact-ledger-Index-vue":"contact-ledger-Index-vue","layout-MainDialog-vue":"layout-MainDialog-vue","search-SearchContacts-vue":"search-SearchContacts-vue","secure-ResetPassword-vue":"secure-ResetPassword-vue","secure-SecureHome-vue":"secure-SecureHome-vue"}[chunkId]||chunkId) + "." + {"ContactGroups-vue":"8bdc3dce","Contacts-vue":"3fad6581","Search-vue":"70814490","auth-Login-vue":"0283d664","auth-Register-vue":"c7eeba5d","chart-LineChart-vue~chart-PieChart-vue":"83aaba21","chart-LineChart-vue":"a218a1c2","chart-PieChart-vue":"d81e53e0","chunk-0e4d91bb":"21eecb6a","chunk-6537b1e9":"41e8738f","chunk-1f4a9ed4":"7eba6e65","contact-communicationHistory-EmailFormDialog-vue":"536d73ed","contact-Group-vue~contact-Index-vue~contact-ledger-List-vue":"5670ae92","contact-Group-vue":"12beb5c1","contact-activities-Index-vue":"c43ce840","contact-communicationHistory-Index-vue":"85217cea","contact-group-Index-vue":"c3590cc4","contact-information-Index-vue":"3205e16b","chunk-1d99c622":"739994fc","chunk-5275ba68":"e696b255","contact-activities-AppointmentFormDialog-vue":"c3092ed8","contact-activities-NoteFormDialog-vue":"cf3dfb3e","contact-information-StudentFormDialog-vue":"28382a65","contact-communicationHistory-SmsFormDialog-vue":"3e49516f","common-PageHeader-vue":"6146c4eb","contact-ContactDetail-vue":"554f829d","contact-Detail-vue":"467430bd","contact-FormDialog-vue":"aa1372bd","contact-Index-vue":"73a94d44","contact-ledger-List-vue":"be31ef82","contact-Header-vue":"d77105c2","contact-activities-AppointmentList-vue":"1770d784","contact-activities-List-vue":"910ea375","contact-activities-NotesList-vue":"0eadd242","contact-communicationHistory-Calls-vue":"d1bd4607","contact-communicationHistory-Email-vue":"c06b0b3d","contact-communicationHistory-Inquiry-vue":"53bfdb85","contact-communicationHistory-Sms-vue":"08f5c6f5","contact-group-Add-vue":"4608dbeb","contact-group-GroupList-vue":"32fd3545","contact-group-GuardianList-vue":"96b568e5","contact-group-StudentList-vue":"9e3a4ed4","contact-information-GroupFormDialog-vue":"4c741df1","contact-information-GroupList-vue":"2131efdd","contact-information-GuardianFormDialog-vue":"79fbaa0e","contact-information-GuardianList-vue":"c1fb98e7","contact-information-InformationFormDialog-vue":"d2ce3958","contact-information-StudentList-vue":"b4d55691","contact-ledger-Index-vue":"4d307364","layout-MainDialog-vue":"69760272","search-SearchContacts-vue":"a3c85052","secure-ResetPassword-vue":"0639e7ae","secure-SecureHome-vue":"01f7e232","chunk-7ce51b8a":"b6cdf1c0","chunk-21714002":"746dcb16","chunk-0c049c92":"f501b093","chunk-2d0b6ed4":"cc1cfedc","chunk-2d0abc75":"beb7bc1d","chunk-2d22234a":"a01aa325","chunk-5a7a374e":"50080d54","chunk-ae32fe4c":"1d8442f8","chunk-01e65030":"0fb2714e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"auth-Login-vue":1,"chunk-0e4d91bb":1,"chunk-6537b1e9":1,"chunk-1f4a9ed4":1,"contact-communicationHistory-EmailFormDialog-vue":1,"contact-Group-vue~contact-Index-vue~contact-ledger-List-vue":1,"contact-Group-vue":1,"chunk-1d99c622":1,"chunk-5275ba68":1,"contact-activities-AppointmentFormDialog-vue":1,"contact-activities-NoteFormDialog-vue":1,"contact-information-StudentFormDialog-vue":1,"contact-communicationHistory-SmsFormDialog-vue":1,"contact-ContactDetail-vue":1,"contact-Detail-vue":1,"contact-Index-vue":1,"contact-activities-AppointmentList-vue":1,"contact-activities-List-vue":1,"contact-activities-NotesList-vue":1,"contact-communicationHistory-Calls-vue":1,"contact-communicationHistory-Inquiry-vue":1,"contact-communicationHistory-Sms-vue":1,"contact-group-Add-vue":1,"contact-information-GroupFormDialog-vue":1,"contact-information-GroupList-vue":1,"contact-information-GuardianFormDialog-vue":1,"contact-information-GuardianList-vue":1,"contact-information-StudentList-vue":1,"layout-MainDialog-vue":1,"search-SearchContacts-vue":1,"chunk-7ce51b8a":1,"chunk-21714002":1,"chunk-0c049c92":1,"chunk-5a7a374e":1,"chunk-ae32fe4c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ContactGroups-vue":"ContactGroups-vue","Contacts-vue":"Contacts-vue","Search-vue":"Search-vue","auth-Login-vue":"auth-Login-vue","auth-Register-vue":"auth-Register-vue","chart-LineChart-vue~chart-PieChart-vue":"chart-LineChart-vue~chart-PieChart-vue","chart-LineChart-vue":"chart-LineChart-vue","chart-PieChart-vue":"chart-PieChart-vue","contact-communicationHistory-EmailFormDialog-vue":"contact-communicationHistory-EmailFormDialog-vue","contact-Group-vue~contact-Index-vue~contact-ledger-List-vue":"contact-Group-vue~contact-Index-vue~contact-ledger-List-vue","contact-Group-vue":"contact-Group-vue","contact-activities-Index-vue":"contact-activities-Index-vue","contact-communicationHistory-Index-vue":"contact-communicationHistory-Index-vue","contact-group-Index-vue":"contact-group-Index-vue","contact-information-Index-vue":"contact-information-Index-vue","contact-activities-AppointmentFormDialog-vue":"contact-activities-AppointmentFormDialog-vue","contact-activities-NoteFormDialog-vue":"contact-activities-NoteFormDialog-vue","contact-information-StudentFormDialog-vue":"contact-information-StudentFormDialog-vue","contact-communicationHistory-SmsFormDialog-vue":"contact-communicationHistory-SmsFormDialog-vue","common-PageHeader-vue":"common-PageHeader-vue","contact-ContactDetail-vue":"contact-ContactDetail-vue","contact-Detail-vue":"contact-Detail-vue","contact-FormDialog-vue":"contact-FormDialog-vue","contact-Index-vue":"contact-Index-vue","contact-ledger-List-vue":"contact-ledger-List-vue","contact-Header-vue":"contact-Header-vue","contact-activities-AppointmentList-vue":"contact-activities-AppointmentList-vue","contact-activities-List-vue":"contact-activities-List-vue","contact-activities-NotesList-vue":"contact-activities-NotesList-vue","contact-communicationHistory-Calls-vue":"contact-communicationHistory-Calls-vue","contact-communicationHistory-Email-vue":"contact-communicationHistory-Email-vue","contact-communicationHistory-Inquiry-vue":"contact-communicationHistory-Inquiry-vue","contact-communicationHistory-Sms-vue":"contact-communicationHistory-Sms-vue","contact-group-Add-vue":"contact-group-Add-vue","contact-group-GroupList-vue":"contact-group-GroupList-vue","contact-group-GuardianList-vue":"contact-group-GuardianList-vue","contact-group-StudentList-vue":"contact-group-StudentList-vue","contact-information-GroupFormDialog-vue":"contact-information-GroupFormDialog-vue","contact-information-GroupList-vue":"contact-information-GroupList-vue","contact-information-GuardianFormDialog-vue":"contact-information-GuardianFormDialog-vue","contact-information-GuardianList-vue":"contact-information-GuardianList-vue","contact-information-InformationFormDialog-vue":"contact-information-InformationFormDialog-vue","contact-information-StudentList-vue":"contact-information-StudentList-vue","contact-ledger-Index-vue":"contact-ledger-Index-vue","layout-MainDialog-vue":"layout-MainDialog-vue","search-SearchContacts-vue":"search-SearchContacts-vue","secure-ResetPassword-vue":"secure-ResetPassword-vue","secure-SecureHome-vue":"secure-SecureHome-vue"}[chunkId]||chunkId) + "." + {"ContactGroups-vue":"31d6cfe0","Contacts-vue":"31d6cfe0","Search-vue":"31d6cfe0","auth-Login-vue":"1ec94768","auth-Register-vue":"31d6cfe0","chart-LineChart-vue~chart-PieChart-vue":"31d6cfe0","chart-LineChart-vue":"31d6cfe0","chart-PieChart-vue":"31d6cfe0","chunk-0e4d91bb":"60ae7828","chunk-6537b1e9":"00eb69d7","chunk-1f4a9ed4":"dbd643f4","contact-communicationHistory-EmailFormDialog-vue":"a4f0ed9a","contact-Group-vue~contact-Index-vue~contact-ledger-List-vue":"3ce72242","contact-Group-vue":"bccfeb0c","contact-activities-Index-vue":"31d6cfe0","contact-communicationHistory-Index-vue":"31d6cfe0","contact-group-Index-vue":"31d6cfe0","contact-information-Index-vue":"31d6cfe0","chunk-1d99c622":"118d3966","chunk-5275ba68":"e30c5647","contact-activities-AppointmentFormDialog-vue":"2e0a20a3","contact-activities-NoteFormDialog-vue":"a4f0ed9a","contact-information-StudentFormDialog-vue":"783dbe8b","contact-communicationHistory-SmsFormDialog-vue":"ca6df252","common-PageHeader-vue":"31d6cfe0","contact-ContactDetail-vue":"a4f0ed9a","contact-Detail-vue":"b203c6b9","contact-FormDialog-vue":"31d6cfe0","contact-Index-vue":"a4f0ed9a","contact-ledger-List-vue":"31d6cfe0","contact-Header-vue":"31d6cfe0","contact-activities-AppointmentList-vue":"b6b92317","contact-activities-List-vue":"b6b92317","contact-activities-NotesList-vue":"b6b92317","contact-communicationHistory-Calls-vue":"6f33d223","contact-communicationHistory-Email-vue":"31d6cfe0","contact-communicationHistory-Inquiry-vue":"6f33d223","contact-communicationHistory-Sms-vue":"6f33d223","contact-group-Add-vue":"ca6df252","contact-group-GroupList-vue":"31d6cfe0","contact-group-GuardianList-vue":"31d6cfe0","contact-group-StudentList-vue":"31d6cfe0","contact-information-GroupFormDialog-vue":"a4f0ed9a","contact-information-GroupList-vue":"a4f0ed9a","contact-information-GuardianFormDialog-vue":"5dcf576c","contact-information-GuardianList-vue":"a4f0ed9a","contact-information-InformationFormDialog-vue":"31d6cfe0","contact-information-StudentList-vue":"a4f0ed9a","contact-ledger-Index-vue":"31d6cfe0","layout-MainDialog-vue":"a4f0ed9a","search-SearchContacts-vue":"75dfffbc","secure-ResetPassword-vue":"31d6cfe0","secure-SecureHome-vue":"31d6cfe0","chunk-7ce51b8a":"ca6df252","chunk-21714002":"304b9992","chunk-0c049c92":"6bcc295c","chunk-2d0b6ed4":"31d6cfe0","chunk-2d0abc75":"31d6cfe0","chunk-2d22234a":"31d6cfe0","chunk-5a7a374e":"dd2cb123","chunk-ae32fe4c":"ca6df252","chunk-01e65030":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
